import { useMutation } from '@tanstack/react-query';

import {
  useRequest,
  type MutationFunction,
  type MutationFunctionContext,
  type RequestQueryObject,
} from '@frontend/api';

import type { DxfSplitVariables } from './types';

const useSplitDxfPartFileKey = ['dxf', 'split'] as const;
export const getUseSplitDxfPartFileKey = () => useSplitDxfPartFileKey;

/**
 * Kicks off splitting a DXF part file into one line item per outer cut contour.
 * Resolves once the split is enqueued, not when it finishes; progress is
 * reported as a `dxfSplit` task status.
 */
export const useSplitDxfPartFile: MutationFunction<
  void,
  DxfSplitVariables,
  [],
  RequestQueryObject
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation<
    void,
    unknown,
    DxfSplitVariables,
    MutationFunctionContext<void>
  >({
    mutationFn: async ({ partFileUuid, ...body }) => {
      await request(`/dxf/${partFileUuid}/split`, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey: getUseSplitDxfPartFileKey(),
  });
};
